module.exports = "/images/oculus-3.jpg";